<template>
	<section>
    <el-col :span="24" class="all">
      <el-col :span="12" class="info">
        <img class="up-area" src="../assets/icon/semi.png" alt="L">
        <div class="logo-area">
          <img class="logo" src="../assets/icon/logo1.png" alt="L">
          <img class="title" src="../assets/icon/title.png" alt="T">
          <img class="subtitle" src="../assets/icon/subtitle.png" alt="S">
        </div>
        <img class="down-area" src="../assets/icon/semi.png" alt="L">
      </el-col>
      <el-col :span="12">
        <el-form :model="ruleForm2" 
                :rules="rules2" 
                ref="ruleForm2" 
                label-position="left" 
                label-width="0px" 
                class="demo-ruleForm login-container">
          <h3 class="title">歡迎登入 SGroup E-learning</h3>
          <el-form-item prop="account">
            <el-input type="text" 
                      v-model="ruleForm2.account" 
                      auto-complete="off" 
                      @keyup.enter.native="handleSubmit2"
                      placeholder="帳號（工號）">
            </el-input>
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input :type="showPass ? 'text' : 'password'" 
                      v-model="ruleForm2.checkPass" 
                      auto-complete="off" 
                      @keyup.enter.native="handleSubmit2"
                      placeholder="密碼">
            </el-input>
            <img :title="showPass? '顯示密碼': '隱藏密碼'" 
                  @click="showPass=!showPass" 
                  style="position: absolute; width: 20px; height: 20px; right: 1rem; top: 0.5rem; cursor: pointer;"
                  :src="showPass?openeye:nopeneye">
          </el-form-item>
          <!--
          <el-checkbox v-model="checked" checked class="remember">記住密碼</el-checkbox>
          -->
          <el-form-item style="width:100%;margin-bottom:12px;">
            <div class="txtBtn" style="float:right;" @click="forgetPwd">忘記密碼</div>
          </el-form-item>
          <el-form-item style="width:100%;;margin-bottom:12px;">
            <el-button type="primary" 
                       style="width:100%;"
                       @click.native.prevent="handleSubmit2" 
                       :loading="logining">登入
            </el-button>
          </el-form-item>
          <div class="txtBtn" style="float:left;" @click="register">沒有帳號？馬上註冊！</div>
          <!-- <div class="txtBtn" style="float:right;" @click="regResult">查看註冊結果</div> -->
          <div class="contact">有無法解決的難題？請聯繫管理員
            <div class="contact-admin">曾德恩 Jeffrey Tseng 
              <a style="margin-left: 7px; font-weight: normal;" 
                href="mailto:jeffrey.te.tseng@foxconn.com">jeffrey.te.tseng@foxconn.com
              </a>
            </div> 
            <!-- <div class="contact-admin">簡采毅 Raymond Chein
              <a style="margin-left: 7px; font-weight: normal;" 
                href="mailto:raymond.ty.chien@foxconn.com">raymond.ty.chien@foxconn.com
              </a>
            </div> -->
          </div>
        </el-form>
      </el-col>
    </el-col>
  </section>
</template>

<script>
  import { requestLogin } from '../api/api';
  import util from '@/common/js/util';
  export default {
    data() {
      return {
        openeye: require('@/assets/icon/ic_eye.png'), 
        nopeneye: require('@/assets/icon/ic_remove_eye.png'),
        message:'',
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '請輸入帳號', trigger: 'blur' },
          ],
          checkPass: [
            { required: true, message: '請輸入密碼', trigger: 'blur' },
          ]
        },
        showPass: false
        //checked: true
      };
    },
    async created() {
      try {
        // 檢查是否有 OAuth token
        let icivicToken = window.localStorage.getItem('has_icivic_login');
        if (!icivicToken || util.auth.isTokenExpired(icivicToken)) {
          // 重定向到第三方登入
          window.location.href = foxdrive_api.getIcivicAuthorizeUrl();
          return;
        }
      } catch (error) {
        console.error('OAuth check failed:', error)
        // 可以顯示錯誤訊息給用戶
      } finally {
        this.loading = false
      }
    },
    methods: {
      handleSubmit2(ev) {
        var _this = this;
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            //_this.$router.replace('/table');
            this.logining = true;
            //NProgress.start();
            var loginParams = { email: this.ruleForm2.account, passwd: this.ruleForm2.checkPass };
            requestLogin(loginParams).then(response => {
              let { code, info } = response;
              _this.logining = false;
              //登入成功
              if(code === 200) {
                if(window.location.hash.indexOf('redirect') === -1) {
                  foxdrive_api.oauthLogin(location.origin + location.pathname); 
                } else {
                  let hash = location.hash.split('redirect=')[1].split('#')[1];
                  foxdrive_api.oauthLogin(location.origin + location.pathname + '#' + hash);
                }
              } else {
              //登入失敗
                _this.$message({
                  message: info,
                  type: 'error'
                });
              }
            }).catch(function (error) {
              //403
              _this.logining = false;
              _this.$message({
                message: error.response.data.info,
                type: 'error'
              });
  	        });	
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      forgetPwd() {
        this.$router.push({ path: '/forgetPwd' });
      },
      register() {
        this.$router.push({ path: '/register' });
      },
      regResult() {
        // this.$router.push({ path: '/regResult' });
      },
      changePass(value) {
        this.visible = !(value === 'show');
      }   
    }
  }
</script>

<style lang="scss" scoped>
  .all {
    height: 100vh;
    overflow-y: hidden;
    .info {
      background-color: #1D2327;
      position: relative;
      height: 100%;
      .up-area {
        position: relative;
        background-size: cover;
        width: 103%;
        height: 31%;
        margin-left: -3%;
      }
      .logo-area {
        position: relative;
        top: 11%;
        text-align: center;
        background-size: cover;
        margin: 0px auto;
        width: fit-content;
        width: -moz-fit-content;
        .logo {
          width: auto;
	        height: auto;
	        max-width: 100%;
	        max-height: 100%;
          display: block;
          margin-bottom: 8px; 
        }
        .title {
          width: auto;
	        height: auto;
	        max-width: 100%;
	        max-height: 100%;
          display: block;
          margin-bottom: 7px; 
        }
        .subtitle {
          width: auto;
	        height: auto;
	        max-width: 100%;
	        max-height: 100%;
          display: block;
        }
      }
      .down-area {
        position: absolute;
        bottom: 0;
        left: 0;
        background-size: cover;  
        width: 103%;
        height: 31%;
        margin-left: -3%;
      }
    }

    .login-container {
      /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
      -webkit-border-radius: 5px;
      border-radius: 5px;
      -moz-border-radius: 5px;
      background-clip: padding-box;
      margin: 200px auto;
      width: 372px;
      padding: 11% 15px 15px 15px;
      background: #fff;
      /*
      border: 1px solid #eaeaea;
      box-shadow: 0 0 25px #cac6c6;
      */
      .title {
        font-size: 18px;
        line-height: 25px; 
        font-weight: 500;
        margin: 0px auto 30px auto;
        text-align: left;
        color: #1D2327;
      }
      .remember {
        margin: 0px 0px 35px 0px;
      }
      .txtBtn {
        float: right;  
        line-height: 20px;
        font-size: 14px;
        color: #1D2327;
        cursor: pointer;
      }
      .txtBtn:hover {
        color: #2E90F4;
      }
      .contact {
        float: left; 
        line-height: 24px;
        font-size: 14px;
        color: #515151;
        position: absolute;
        bottom: 62px;
        .contact-admin {
          display: table;
          font-weight: 600;
        }
      }
      @media (max-height: 600px) {
        .contact {
          display: none;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Login.vue?31e002b8